import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
import './UpdatePassword.css';

function UpdatePassword() {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false); // Loading state for API call
    const [showPassword, setShowPassword] = useState(false); // State for toggling password visibility
    const [showConfirmPassword, setShowConfirmPassword] = useState(false); // State for toggling confirm password visibility
    const navigate = useNavigate(); // Initialize useNavigate

    const validatePasswords = () => {
        if (!password || !confirmPassword) {
            return 'Both password fields are required.';
        }
        if (password.length < 6) {
            return 'Password must be at least 6 characters.';
        }
        if (password !== confirmPassword) {
            return 'Passwords do not match.';
        }
        return '';
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const validationError = validatePasswords();
        if (validationError) {
            setError(validationError);
            setSuccess(false);
        } else {
            setError('');
            setSuccess(false);
            setLoading(true);

            // Replace "user_id" with the actual user ID
            const userId = sessionStorage.getItem('user_id')
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                password: password,
                user_id: userId,
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            fetch("https://api.libaonline.com/api/v1/password", requestOptions)
                .then((response) => response.json()) // Parse response as JSON
                .then((result) => {
                    setLoading(false);
                    if (result?.status === 200) {
                        setSuccess(true);
                        setError(''); // Clear any error
                        // After 10 seconds, navigate to the homepage ('/')
                        setTimeout(() => {
                            navigate('/');
                        }, 1000);
                    } else {
                        setError('Failed to update password. Please try again.');
                        setSuccess(false);
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    setError('An error occurred while updating the password. Please try again.');
                    setSuccess(false);
                    console.error("API Error:", error);
                });
        }
    };

    return (
        <div className="d-flex align-items-center justify-content-center vh-100 password">
            <div className="card p-4" style={{ width: '400px' }}>
                <h3 className="text-center">Update Password</h3>
                {success ? (
                    <div className="alert alert-success text-center">
                        Your password has been updated successfully!
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="password" className="form-label">
                                New Password
                            </label>
                            <div className="input-group">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className={`form-control ${error ? 'is-invalid' : ''}`}
                                    id="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Enter new password"
                                />
                                <span
                                    className="input-group-text"
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} />
                                </span>
                            </div>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="confirmPassword" className="form-label">
                                Confirm Password
                            </label>
                            <div className="input-group">
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    className={`form-control ${error ? 'is-invalid' : ''}`}
                                    id="confirmPassword"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Re-enter new password"
                                />
                                <span
                                    className="input-group-text"
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <i className={`fas ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`} />
                                </span>
                            </div>
                        </div>
                        {error && <div className="text-danger mb-3">{error}</div>}
                        <button
                            type="submit"
                            className="btn btn-primary w-100"
                            disabled={loading} // Disable the button while loading
                        >
                            {loading ? "Updating..." : "Update Password"}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}

export default UpdatePassword;
